document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantesProducto();
  initComparador();
  initBarraCompra();
});

function initBarraCompra() {
  var rail = document.querySelector('[data-mt-buy-rail]');
  var objetivo = document.getElementById('comprar');
  if (!rail || !objetivo) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          rail.classList.remove('mt-visible');
        } else if (entry.boundingClientRect.top < 0) {
          rail.classList.add('mt-visible');
        } else {
          rail.classList.remove('mt-visible');
        }
      });
    },
    { threshold: 0 }
  );
  observer.observe(objetivo);

  rail.addEventListener('click', function (e) {
    e.preventDefault();
    objetivo.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-mt-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('mt-visible');
          }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var principal = document.querySelector('[data-mt-gal-principal]');
  if (!principal) return;
  var minis = document.querySelectorAll('[data-mt-gal-mini]');
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      principal.querySelector('img').setAttribute('src', src);
      principal.querySelector('img').setAttribute('alt', alt);
      minis.forEach(function (m) { m.classList.remove('mt-activa'); });
      mini.classList.add('mt-activa');
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var pills = document.querySelectorAll('[data-mt-pill]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioAntesEl = document.querySelector('[data-mt-precio-antes]');
  var precioRailEl = document.querySelector('[data-mt-precio-rail]');
  var submitBtn = form.querySelector('[data-mt-submit]');
  var buynowLink = form.querySelector('[data-mt-buynow]');
  var agotadoMsg = document.querySelector('[data-mt-agotado]');
  var textoDisponible = form.getAttribute('data-texto-disponible') || 'Añadir al carrito';
  var textoAgotado = form.getAttribute('data-texto-agotado') || 'Agotado';

  var seleccion = {};
  pills.forEach(function (p) {
    if (p.classList.contains('mt-activa')) {
      seleccion[p.getAttribute('data-option-name')] = p.getAttribute('data-option-value');
    }
  });

  function actualizar() {
    var match = variantes.find(function (v) {
      return v.options.every(function (opt, i) {
        return seleccion[v.optionNames[i]] === opt;
      });
    });
    if (!match) return;
    idInput.value = match.id;
    if (precioEl) precioEl.textContent = match.priceFormatted;
    if (precioRailEl) precioRailEl.textContent = match.priceFormatted;
    if (precioAntesEl) {
      if (match.compareAtPriceFormatted) {
        precioAntesEl.textContent = match.compareAtPriceFormatted;
        precioAntesEl.style.display = '';
      } else {
        precioAntesEl.style.display = 'none';
      }
    }
    if (match.available) {
      submitBtn.disabled = false;
      submitBtn.textContent = textoDisponible;
      if (agotadoMsg) agotadoMsg.style.display = 'none';
      if (buynowLink) {
        buynowLink.href = '/cart/' + match.id + ':1';
        buynowLink.style.pointerEvents = '';
        buynowLink.style.opacity = '';
        buynowLink.removeAttribute('aria-disabled');
      }
    } else {
      submitBtn.disabled = true;
      submitBtn.textContent = textoAgotado;
      if (agotadoMsg) agotadoMsg.style.display = '';
      if (buynowLink) {
        buynowLink.style.pointerEvents = 'none';
        buynowLink.style.opacity = '0.5';
        buynowLink.setAttribute('aria-disabled', 'true');
      }
    }
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var name = pill.getAttribute('data-option-name');
      document.querySelectorAll('[data-mt-pill][data-option-name="' + CSS.escape(name) + '"]').forEach(function (p) {
        p.classList.remove('mt-activa');
      });
      pill.classList.add('mt-activa');
      seleccion[name] = pill.getAttribute('data-option-value');
      actualizar();
    });
  });

  if (pills.length) actualizar();
}

function initComparador() {
  var comps = document.querySelectorAll('[data-mt-comp]');
  if (!comps.length) return;

  comps.forEach(function (comp) {
    var before = comp.querySelector('[data-mt-comp-before]');
    var beforeImg = before ? before.querySelector('img') : null;
    var afterImg = comp.querySelector('[data-mt-comp-after] img');
    var handle = comp.querySelector('[data-mt-comp-handle]');
    var dragging = false;

    function sizeImages() {
      var w = comp.getBoundingClientRect().width;
      if (beforeImg) beforeImg.style.width = w + 'px';
      if (afterImg) afterImg.style.width = w + 'px';
    }

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      before.style.width = pct + '%';
      handle.style.left = pct + '%';
    }

    function posFromEvent(e) {
      var rect = comp.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    }

    sizeImages();
    window.addEventListener('resize', sizeImages);

    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      comp.setPointerCapture && comp.setPointerCapture(e.pointerId);
    });
    comp.addEventListener('pointerdown', function (e) {
      dragging = true;
      setPos(posFromEvent(e));
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(posFromEvent(e));
    });
    window.addEventListener('pointerup', function () { dragging = false; });
    window.addEventListener('pointercancel', function () { dragging = false; });

    if (comp.getAttribute('data-mt-comp-auto') === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var angle = 0;
      var lastTs = null;
      var periodMs = 7000; // slow, full back-and-forth cycle
      var speed = (2 * Math.PI) / periodMs;
      requestAnimationFrame(function autoStep(ts) {
        if (lastTs === null) lastTs = ts;
        var dt = ts - lastTs;
        lastTs = ts;
        if (!dragging) {
          angle += dt * speed;
          setPos(50 + 34 * Math.sin(angle));
        }
        requestAnimationFrame(autoStep);
      });
    }
  });
}
